// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"05358942","465":"82aa7007"}[chunkId] + ".chunk.js";
};